import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";

// Same component as dm-commerce-b2b-web (CustomInput), with the hard-coded
// colors swapped for the palette variables so brand/dark mode apply.
export const CustomInput = styled(TextField)(() => ({
  width: "100%",
  "& .MuiInputBase-root": {
    height: "45px",
    fontSize: "14px",
    padding: "0 0px",
    color: "var(--color-text)",
    backgroundColor: "var(--color-bg-white)",
    borderRadius: "4px",
    fontFamily: "inherit",
    boxSizing: "border-box",
    transition: "all 0.3s ease-in-out",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      border: "1px solid var(--color-input-border)",
    },
    "&:hover fieldset": {
      border: "1px solid var(--color-primary)",
    },
    "&.Mui-focused fieldset": {
      border: "1px solid var(--color-primary)",
    },
    "&.Mui-error fieldset": {
      border: "1px solid var(--color-danger)",
    },
  },
  // multiline (textarea): grow with the content instead of the fixed 45px
  "& .MuiInputBase-root.MuiInputBase-multiline": {
    height: "auto",
    padding: "10px 12px",
  },
  "& .MuiInputBase-input": {
    fontWeight: 500,
  },
  "& .MuiInputBase-input:focus": {
    fontWeight: 500,
  },
  "& .MuiFormHelperText-root": {
    color: "var(--color-danger)",
    fontSize: "12px",
    fontFamily: "inherit",
  },
}));
